'use client';

import { Icon } from './Icon';

import type { StarfishIconRef } from './starfish';

type Props = {
  icon: StarfishIconRef | string;
  size: number;
  alt?: string;
  className?: string;
};

/**
 * Draws an icon that has been *named*, or falls back to an asset URL.
 *
 * The string branch is for multi-colour brand artwork kept in `public/` — the
 * lastminute deals gradient, Pink People, TSH, loyalty. A colorize flattens an
 * image to one colour, so those cannot come from the design system set, and a
 * slot that shows either kind takes either kind.
 */
export const IconOrLegacyAsset = ({ icon, size, alt = '', className }: Props) => {
  if (typeof icon === 'string') return <img src={icon} width={size} height={size} alt={alt} className={className} />;

  const { inkScale, ...ref } = icon;

  return (
    <Icon
      {...ref}
      size={inkScale ? Math.round(size * inkScale) : size}
      footprint={inkScale ? size : undefined}
      alt={alt}
      className={className}
    />
  );
};
